
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { initClient } from '../../api';
import { IUserBase, SurveyOverviewUiClient, SurveyResultMeta } from '../backend/backendapi';
import { formatDateTime, WindowType } from '../../util';
import { paginationOptions, searchOptions } from '../../util/vue-good-table';
import Toasted from 'vue-toasted';
import SurveyJSComponent, { SurveyUser } from './SurveyJSComponent';
import AttachmentsButtonIfPresent from './AttachmentsButtonIfPresent';
import { getLocalizedSurveyName } from './utils';

Vue.use(Toasted, { duration: 2000 });

declare var window: WindowType;

@Component({
  components: {
    AttachmentsButtonIfPresent,
    SurveyJSComponent,
    VueGoodTable,
  },
})
export default class Overview extends Vue {
  readonly api = initClient(SurveyOverviewUiClient);
  loading = false;
  surveysMeta: SurveyResultMeta[] = [];
  tab: 'list' | 'survey' = 'list';
  surveyComponentProps: { surveyId: string, started: Date, user: SurveyUser }
      = { surveyId: '', started: new Date(), user: { firstName: '', lastName: '', email: '', company: '' } };

  get columnsConfig(): any[] {
    return [
      {
        label: this.$i18n.t('survey.surveyResultMeta.model.surveyName').toString(),
        field: (e: SurveyResultMeta) => getLocalizedSurveyName(e.surveyNames, e.surveyName, this.$i18n.locale),
        isSurveyNameColumn: true,
      }, {
        label: this.$t('survey.surveyResultMeta.model.date').toString(),
        // e.date is nullable, but somehow the openapi generator does not properly generate the spec
        // also: if returned value is undefined, vgt does not render the cell at all, so we return null here in case the date is undefined
        field: (e: SurveyResultMeta) => e.date ?? null,
        type: 'date',
        formatFn: (e: Date | undefined) => !e ? this.$t('general.unknown').toString() : formatDateTime(e),
      }, {
        label: this.$t('survey.surveyResultMeta.model.passed').toString(),
        field: (e: SurveyResultMeta) => e.passed,
        formatFn: (value: boolean) => this.$t(value ? 'yes' : 'no').toString(),
      }, {
        label: this.$t('survey.surveyResultMeta.model.validTil').toString(),
        type: 'date',
        field: (e: SurveyResultMeta) => e.validTil,
        formatFn: (e: Date | undefined) => !e ? '' : formatDateTime(e),
      }, {
        label: this.$i18n.t('survey.overview.list.actions').toString(),
        field: 'actions',
        width: '5em',
      },
    ];
  }

  get paginationOptions(): any {
    return paginationOptions(this.$i18n);
  }

  get searchOptions(): any {
    return searchOptions(this.$i18n);
  }

  get user(): IUserBase {
    return window.application.user;
  }

  async mounted(): Promise<void> {
    this.loading = true;
    try {
      await this.loadSurveysMeta();
    } finally {
      this.loading = false;
    }
  }

  async loadSurveysMeta(): Promise<void> {
    this.surveysMeta = await this.api.getSurveysResultMeta();
  }

  async onSurveyBack(): Promise<void> {
    this.tab = 'list';
    await this.loadSurveysMeta();
  }

  openSurvey(meta: SurveyResultMeta): void {
    this.surveyComponentProps = {
      surveyId: meta.surveyId,
      started: new Date(),
      user: {
        firstName: this.user.firstName!,
        lastName: this.user.lastName!,
        email: this.user.userName!,
        // company: this.user.company,
        company: '',
      },
    };
    this.tab = 'survey';
  }
}
